import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button }
from '@mui/material';

const WidgetFormDialog = ({ open, title, children, onClose, onAccept }) => {
    return (
        <Dialog open={open} fullWidth maxWidth="sm" onClose={onClose}>
            <DialogTitle>{title}</DialogTitle>

            <DialogContent dividers>
                {children}
            </DialogContent>

            <DialogActions>
                <Button onClick={onClose} color="secondary">Cancelar</Button>
                <Button onClick={onAccept} variant="contained">
                    Aceptar
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default WidgetFormDialog;
